import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[host-component]'
})
export class HostComponentDirective {
  constructor(public viewRef: ViewContainerRef) {
  }
}
